import React from "react";
import { TextField } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";

const useStyles = makeStyles({
  shop: { color: "green" },
  abroad: { color: "green" },
  wh: {
    background: "#ACD1AF",
    color: "white",
  },
});

const ColoredTextFieldForRbh = props => {
  const classes = useStyles();

  if (props?.record?.[props?.source] === null) return null;

  const isWh = props => {
    if (props.record.whCount > 0 && props.source === "whCount") return true;
    return false;
  };

  return (
    <TextField
      className={classnames({
        [classes.wh]: isWh(props),
      })}
      style={{
        display: "grid",
        alignContent: "center",
        alignItems: "center",
        justifyItems: "center",
        justifyContent: "center",
        padding: "7px 30px",
      }}
      {...props}
    />
  );
};

ColoredTextFieldForRbh.defaultProps = TextField.defaultProps;

export default ColoredTextFieldForRbh;
